import React from 'react'

const ModalHeader = ({toggle}) => {
  return (
    <div>{!toggle ? "Login" : "Guest"}</div>
  )
}

export default ModalHeader